export const SETTINGS = {
    'staticTestAPIRoot': './dist/dev/assets/static/',
    'TOKEN_NAME': 'ttp_token',
};
